import React from "react";
import { Button, Flex, Space, Typography, theme } from "antd";
import { Link } from "react-router-dom";

const { Title, Text } = Typography;

// ── Types ─────────────────────────────────────────────────────────────────────

interface HeroAction {
    label: string;
    icon?: React.ReactNode;
    onClick?: () => void;
    to?: string;
    type?: "primary" | "default" | "dashed" | "text" | "link";
    disabled?: boolean;
}

interface headerPageProps {
    title: string;
    subtitle?: string;
    actions?: HeroAction[];
}

// ── Component ─────────────────────────────────────────────────────────────────

const HeaderPage: React.FC<headerPageProps> = ({ title, subtitle, actions = [] }) => {
    const { token } = theme.useToken();

    const renderButton = (action: HeroAction) => {
        const btn = (
            <Button
                key={action.label}
                type={action.type ?? "default"}
                icon={action.icon}
                disabled={action.disabled}
                onClick={action.onClick}
                style={{
                    borderRadius: token.borderRadiusLG,
                    fontWeight: 700,
                    ...(action.type !== "primary" && !action.disabled
                        ? { borderColor: token.colorPrimary, color: token.colorPrimary }
                        : {}),
                }}
            >
                {action.label}
            </Button>
        );

        return action.to ? (
            <Link key={action.label} to={action.to}>
                {btn}
            </Link>
        ) : (
            btn
        );
    };

    return (
        <Flex justify="space-between" align="flex-start" wrap gap={16} style={{ marginBottom: 28 }}>
            <div>
                <Title level={3} style={{ margin: 0, fontWeight: 900, letterSpacing: "-0.02em" }}>
                    {title}
                </Title>
                {subtitle && (
                    <Text type="secondary" style={{ fontSize: 13 }}>
                        {subtitle}
                    </Text>
                )}
            </div>

            {actions.length > 0 && (
                <Space wrap>{actions.map(renderButton)}</Space>
            )}
        </Flex>
    );
};

export default HeaderPage;